import { render, staticRenderFns } from "./PrimaryBox.vue?vue&type=template&id=61ed14b9&scoped=true&"
import script from "./PrimaryBox.vue?vue&type=script&lang=js&"
export * from "./PrimaryBox.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryBox.vue?vue&type=style&index=0&id=61ed14b9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ed14b9",
  null
  
)

export default component.exports